import { motion } from "framer-motion";

const Stat = ({ value, label, accent, id }) => (
  <div data-testid={id}>
    <div className={`font-display text-5xl font-semibold tracking-tight ${accent ? "text-violet-400" : "text-white"}`}>{value}</div>
    <div className="mt-2 text-xs font-medium uppercase tracking-[0.2em] text-zinc-400">{label}</div>
  </div>
);

export const Stats = ({ products, inStock }) => (
  <motion.div
    initial={{ opacity: 0, y: 16 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.6 }}
    data-testid="stats-banner"
    className="flex gap-14"
  >
    <Stat value={products} label="Products" id="stats-products-count" />
    <Stat value={inStock} label="In stock" accent id="stats-stock-count" />
  </motion.div>
);
